import { render, staticRenderFns } from "./RegSuccess.vue?vue&type=template&id=163632ee&scoped=true"
import script from "./RegSuccess.vue?vue&type=script&lang=js"
export * from "./RegSuccess.vue?vue&type=script&lang=js"
import style0 from "./RegSuccess.vue?vue&type=style&index=0&id=163632ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163632ee",
  null
  
)

export default component.exports